import { lazy } from "react";
import { Routes, Route } from "react-router-dom";
import ItemGroupAddPage from "../pages/item/ItemGroupAddPage";
import ItemGroupUpdatePage from "../pages/item/ItemGroupUpdatePage";
import ItemDetails from "../pages/item/ItemDetails";
import DiscountList from "../pages/Discount/DiscountList";
import Challenge from "../pages/challenges/Challenge";
import Carousel from "../pages/carousel/carousel";
import Subscription from "../pages/subscription/Subscription";
import Topups from "../pages/topups/Topups";
import UserSubscription from "../pages/user_subscription/UserSubscription";
import Category from "../pages/category/Category";
import Payment from "../pages/payment/payment";
import Subscriptions from "../pages/payment/subscriptions";
import Role from "../pages/role/rolelist";
import ForgotPassword from "../pages/forgetpassword/Forgetpassword";
import ResetPassword from "../pages/forgetpassword/ResetPassword";
import Activitylogs from "../pages/activitylogs/activitylogs";
import Feedback from "../pages/feedback/Feedback";
import QuestPacks from "../pages/questpacks/QuestPacks";
import QuestPackFormPage from "../pages/questpacks/QuestPackFormPage";
import HuntPacks from "../pages/huntpacks/HuntPacks";
import HuntPackFormPage from "../pages/huntpacks/HuntPackFormPage";
import PurchaseStats from "../pages/purchase/PurchaseStats";
import Analytics from "../pages/analytics/Analytics";
import Profile from "../pages/profile/Profile";
import Settings from "../pages/profile/Settings";

const AuthRoute = lazy(() => import("../routes/AuthRoute"));
const PrivateRoute = lazy(() => import("../routes/PrivateRoute"));
const Login = lazy(() => import("../pages/login/Login"));
const Layout = lazy(() => import("../layout/Layout"));
const Dashboard = lazy(() => import("../pages/dashboard/Dashboard"));
const User = lazy(() => import("../pages/user/User"));
const AdminUsers = lazy(() => import("../pages/adminUsers/AdminUsers"));
const AdminAudit = lazy(() => import("../pages/adminUsers/AdminAudit"));
const DeletedAccounts = lazy(() => import("../pages/deletedAccounts/DeletedAccounts"));
const NotFound = lazy(() => import("../pages/NotFound"));
const Company = lazy(() => import("../pages/company/Company"));
const Game = lazy(() => import("../pages/game/Game"));
const Items = lazy(() => import("../pages/item/Items"));
const SubCategory = lazy(() => import("../pages/sub_category/Sub_category"));

const App = () => {
  return (
    <Routes>
      <Route element={<AuthRoute />}>
        <Route path="/login" element={<Login />} />
        <Route path="forgot-password" element={<ForgotPassword />} />
        <Route path="reset-password" element={<ResetPassword />} />
      </Route>
      <Route element={<PrivateRoute />}>
        <Route path="/" element={<Layout />}>
          <Route path="" element={<Dashboard />} />
          <Route path="user" element={<User />} />
          <Route path="deleted-accounts" element={<DeletedAccounts />} />
          <Route path="admin-users" element={<AdminUsers />} />
          <Route path="admin-audit" element={<AdminAudit />} />
          <Route path="company" element={<Company />} />
          <Route path="hunt" element={<Game />} />
          <Route path="items" element={<Items />} />
          <Route path="add-package" element={<ItemGroupAddPage />} />
          <Route path="edit-package" element={<ItemGroupUpdatePage />} />
          <Route path="detail-package" element={<ItemDetails />} />
          <Route path="discount" element={<DiscountList />} />
          
          <Route path="Quest" element={<Challenge />} />
          <Route path="quest-packs" element={<QuestPacks />} />
          <Route path="add-quest-pack" element={<QuestPackFormPage mode="create" />} />
          <Route path="edit-quest-pack" element={<QuestPackFormPage mode="edit" />} />
          <Route path="hunt-packs" element={<HuntPacks />} />
          <Route path="add-hunt-pack" element={<HuntPackFormPage mode="create" />} />
          <Route path="edit-hunt-pack" element={<HuntPackFormPage mode="edit" />} />
          <Route path="carousel" element={<Carousel />} />
          <Route path="subscription" element={<Subscription />} />
          <Route path="add-ons" element={<Topups />} />
          <Route path="user-subscription" element={<UserSubscription />} />
          <Route path="category" element={<Category />} />
          <Route path="subcategory" element={<SubCategory />} />
          <Route path="roles" element={<Role />} />
          <Route path="activity-logs" element={<Activitylogs />} />
          <Route path="feedbacks" element={<Feedback />} />
          <Route path="purchase-stats" element={<PurchaseStats />} />
          <Route path="analytics" element={<Analytics />} />
          <Route path="profile" element={<Profile />} />
          <Route path="settings" element={<Settings />} />
          <Route path="*" element={<NotFound />} />

        </Route>
      </Route>
      <Route path="/payment" element={<Payment />} />
      {/* Opaque single-use handoff — never put a session JWT in the path. */}
      <Route path="/subscriptions/handoff/:code" element={<Subscriptions />} />
      <Route path="/subscriptions" element={<Subscriptions />} />
      {/* Legacy token-in-URL route kept for deep-link compatibility; page refuses JWTs. */}
      <Route path="/subscriptions/:token/:userid" element={<Subscriptions />} />
    </Routes>
  );
};

export default App;
